const fullFormatter = new Intl.DateTimeFormat('ja-JP-u-ca-japanese', {
  era: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  timeZone: 'UTC',
});

const yearFormatter = new Intl.DateTimeFormat('ja-JP-u-ca-japanese', {
  era: 'long',
  year: 'numeric',
  timeZone: 'UTC',
});

const monthDayFormatter = new Intl.DateTimeFormat('ja-JP', {
  month: 'long',
  day: 'numeric',
  timeZone: 'UTC',
});

function parseIsoDate(isoDate: string): Date {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(isoDate);
  if (!m) {
    throw new Error(`invalid ISO date: ${isoDate}`);
  }
  const [, y, mo, d] = m;
  return new Date(Date.UTC(Number(y), Number(mo) - 1, Number(d)));
}

/**
 * ISO 形式の日付 (YYYY-MM-DD) を和暦表記 (例: 令和7年3月25日) に変換する。
 * meta.toml の published/updated を旧サイト同様の表記で表示するために使う。
 */
export function formatWareki(isoDate: string): string {
  return fullFormatter.format(parseIsoDate(isoDate));
}

/** 和暦の年表記 (例: 令和7年)。更新履歴の年見出しに使う。 */
export function warekiYear(isoDate: string): string {
  return yearFormatter.format(parseIsoDate(isoDate));
}

/** 月日表記 (例: 3月25日)。更新履歴の行に使う。 */
export function formatMonthDay(isoDate: string): string {
  return monthDayFormatter.format(parseIsoDate(isoDate));
}

/**
 * 記事の日付表示ラベル。日付が無い場合は旧サイトの表記に合わせて
 * published → 「古の記録」、planned → 「未定」とする。
 */
export function dateLabel(status: 'published' | 'planned', isoDate: string | null): string {
  if (isoDate) {
    return formatWareki(isoDate);
  }
  return status === 'published' ? '古の記録' : '未定';
}
